import React, { useEffect, useState } from "react";

const MESSAGES = [
  "YOUTH CAFÉ & MUSIC VENUE",
  "LIVE MUSIC • GAMES • FOOD",
  "WELCOME TO YAZ BY NEAD",
  "GOOD VIBES ONLY",
];

export default function TvSignage() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % MESSAGES.length), 3500);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="min-h-screen bg-black overflow-hidden relative flex items-center justify-center">
      <div className="tv-blob tv-blob-1" />
      <div className="tv-blob tv-blob-2" />
      <div className="tv-blob tv-blob-3" />
      <div
        className="absolute inset-0 opacity-[0.05]"
        style={{ backgroundImage: "radial-gradient(#fff 1px, transparent 1px)", backgroundSize: "3px 3px" }}
      />

      <div className="relative z-10 text-center px-8">
        <div className="tv-logo-wrap flex justify-center">
          <img src="/yaz-logo.png" alt="YAZ by NEAD" className="tv-logo-img" />
        </div>

        <div className="h-14 md:h-20 mt-8 md:mt-12 flex items-center justify-center">
          <p
            key={i}
            className="tv-msg font-display font-bold text-xl md:text-4xl tracking-[0.25em] md:tracking-[0.35em] text-white/90"
          >{MESSAGES[i]}</p>
        </div>
      </div>

      <div className="absolute bottom-6 md:bottom-10 left-0 right-0 overflow-hidden">
        <div className="tv-marquee whitespace-nowrap font-display font-bold text-base md:text-xl tracking-[0.4em] text-[#00F0FF]/70">
          {"YAZ BY NEAD • YOUTH CAFÉ • MUSIC VENUE • GAMES • LIVE EVENTS • ".repeat(4)}
        </div>
      </div>
    </div>
  );
}
